import Vue from 'vue';
import axios from 'axios';
import contentSort from '@/app/utils/contentSortingUtil';
import { debug } from '@/app/utils/debug';

import {
  SET_ACTIVE_CONTENT_TYPE,
  SET_ACTIVE_FOLDER_ITEM,
  SET_ACTIVE_NAV_MENU_ITEM_ID,
  SET_ACTIVE_SUB_ACCOUNT_DISPLAY_NAME,
  SET_ACTIVE_SUB_ACCOUNT_ID,
  SET_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID,
  SET_ACTIVE_VERSION_PATH,
  SET_ACTIVE_VOLUME_PATH,
  SET_ACTIVE_VOLUME_SUBSCRIPTION,
  SET_CHECK_SUB_ACCOUNT_STATUS,
  SET_CONTENT_ITEMS,
  SET_CREATE_SHARED_LINK_STATUS,
  SET_DELETE_SHARED_LINK_STATUS,
  SET_FETCH_CONTENT_ITEMS_STATUS,
  SET_FETCH_FILE_VERSIONS_STATUS,
  SET_FETCH_SHARED_CONTENT_ITEMS_STATUS,
  SET_FETCH_SHARED_LINK_SETTINGS_STATUS,
  SET_FETCH_STORAGE_SPACE_STATUS,
  SET_FETCH_SUB_ACCOUNT_ITEMS_STATUS,
  SET_FILE_VERSIONS,
  SET_POST_LOGIN_OPEN_NAV_MENU_ID,
  SET_SEARCH_ENABLED_SATE,
  SET_SEARCH_RESULT_RECEIVED,
  SET_SETUP_PASSWORD_STATUS,
  SET_SHARED_CONTENT_ITEMS,
  SET_SHARED_LINK,
  SET_SHARED_LINK_SETTINGS,
  SET_STORAGE_SPACE,
  SET_SUB_ACCOUNT_ITEMS,
  SET_VOLUME_SB_MACHINES,
  SET_UPDATE_SHARED_LINK_SETTINGS_STATUS,
  SET_USER_SUBSCRIPTION,
  SET_FETCH_SUB_ACCOUNT_ARCHIVES_STATUS,
  SET_SUB_ACCOUNT_ARCHIVES
} from './mutation-types';

import {
  CHECK_SUB_ACCOUNT_EXISTS,
  CREATE_SHARED_LINK,
  DELETE_SHARED_LINK,
  FETCH_CONTENT_ITEMS,
  FETCH_FILE_VERSIONS,
  FETCH_SHARED_CONTENT_ITEMS,
  FETCH_SHARED_LINK_SETTINGS,
  FETCH_STORAGE_SPACE,
  FETCH_SUB_ACCOUNT_ITEMS,
  RESET_ARCHIVE_PASSWORD_STATUS,
  SEARCH_CONTENT_ITEMS,
  SETUP_ARCHIVE_PASSWORD,
  SORT_CONTENT_ITEMS,
  SORT_SHARED_CONTENT_ITEMS,
  UPDATE_ACTIVE_CONTENT_TYPE,
  UPDATE_ACTIVE_NAV_MENU_ITEM_ID,
  UPDATE_ACTIVE_SUB_ACCOUNT,
  UPDATE_ACTIVE_VERSION_PATH,
  UPDATE_ACTIVE_VOLUME_PATH,
  UPDATE_SHARED_LINK_SETTINGS,
  FETCH_SUB_ACCOUNT_ARCHIVES,
  UPDATE_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID
} from './action-types';

import {
  COMPLETED_STATUS,
  ERROR_STATUS,
  PENDING_STATUS,
  SUCCESS_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import { CONTENT_TABLE_TYPE, UNDEFINED_CONTENT_TYPE } from './active-content-type';

const defaultNavMenuItemId = 'account';

const defaultSortOptions = { columnName: 'displayName', sortOrder: 'ascending' };
let contentTableSortOptions = defaultSortOptions;


let isNotSendSharedLinksStatistic = true;

function sendSharedLinksStatistic(data) {
  if (isNotSendSharedLinksStatistic && data) {
    isNotSendSharedLinksStatistic = false;

    const sharedLinks = data.length;

    Vue.gtm.push({
      event: 'Acronis',
      eventCategory: 'WRE_data',
      eventAction: 'Number_of_shared_links',
      eventLabel: sharedLinks > 0 ? sharedLinks : 'none'
    });

    const sharedDownloads = data.reduce((accumulator, value) => accumulator + value.hitCount, 0);

    Vue.gtm.push({
      event: 'Acronis',
      eventCategory: 'WRE_data',
      eventAction: 'Number_of_downloads',
      eventLabel: sharedDownloads > 0 ? sharedDownloads : 'none'
    });
  }
}

function loadActiveSubAccount(commit, subAccounts) {
  const savedMenuId = window.localStorage.getItem('activeNavMenuItem');
  if (savedMenuId !== undefined && savedMenuId !== null && savedMenuId !== '') {
    commit(SET_POST_LOGIN_OPEN_NAV_MENU_ID, { id: savedMenuId });
  } else {
    commit(SET_POST_LOGIN_OPEN_NAV_MENU_ID, { id: defaultNavMenuItemId });
  }

  if (subAccounts.length <= 0) {
    return;
  }

  let activeSubAccountDisplayName =
    window.localStorage.getItem('activeSubAccountDisplayName');
  let activeSubAccountVolumeSubscription =
    window.localStorage.getItem('activeSubAccountVolumeSubscription') === 'true';
  let activeSubAccountId =
    window.localStorage.getItem('activeSubAccountId');

  let isSubAccountExists = false;

  if (activeSubAccountId !== undefined
    && activeSubAccountId !== null
    && activeSubAccountId !== '') {
    const sbNumberId = Number(activeSubAccountId);
    isSubAccountExists = subAccounts.some(sb => sb.id === sbNumberId);
  }

  if (isSubAccountExists === false) {
    const subAccount = subAccounts[0];

    activeSubAccountId = subAccount.id;
    activeSubAccountVolumeSubscription = subAccount.volumeSubscription;
    activeSubAccountDisplayName = subAccount.displayName;
  }

  commit(SET_ACTIVE_VOLUME_SUBSCRIPTION, Boolean(activeSubAccountVolumeSubscription));
  commit(SET_ACTIVE_SUB_ACCOUNT_DISPLAY_NAME, activeSubAccountDisplayName);
  commit(SET_ACTIVE_SUB_ACCOUNT_ID, Number(activeSubAccountId));
}

export default {
  async [CHECK_SUB_ACCOUNT_EXISTS]({ commit }) {
    commit(SET_CHECK_SUB_ACCOUNT_STATUS, PENDING_STATUS);
    commit(SET_SUB_ACCOUNT_ITEMS, []);

    await axios.get('/subAccounts', {
      params: {
        calcUsedSpace: false
      }
    }).then(function (response) {
      const subAccounts = response.data.subAccounts !== undefined ? response.data.subAccounts : [];
      loadActiveSubAccount(commit, subAccounts);
      commit(SET_SUB_ACCOUNT_ITEMS, subAccounts);
    }).finally(function () {
      commit(SET_CHECK_SUB_ACCOUNT_STATUS, UNDEFINED_STATUS);
    });
  },
  async [FETCH_SUB_ACCOUNT_ITEMS]({ commit }) {
    commit(SET_FETCH_SUB_ACCOUNT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_SUB_ACCOUNT_ITEMS, []);
    await axios.get('/subAccounts', {
      params: {
        calcUsedSpace: true
      }
    }).then(function (response) {
      const subAccounts = response.data.subAccounts !== undefined ? response.data.subAccounts : [];
      const machines = response.data.machines !== undefined ? response.data.machines : [];
      commit(SET_SUB_ACCOUNT_ITEMS, subAccounts);
      commit(SET_VOLUME_SB_MACHINES, machines);
    }).finally(function () {
      commit(SET_FETCH_SUB_ACCOUNT_ITEMS_STATUS, UNDEFINED_STATUS);
    });
  },
  [UPDATE_ACTIVE_SUB_ACCOUNT]({ commit, dispatch }, activeSubAccount) {
    window.localStorage
      .setItem('activeSubAccountDisplayName', activeSubAccount.displayName);
    window.localStorage
      .setItem('activeSubAccountVolumeSubscription', activeSubAccount.volumeSubscription);
    window.localStorage
      .setItem('activeSubAccountId', activeSubAccount.id);

    commit(SET_ACTIVE_SUB_ACCOUNT_DISPLAY_NAME, activeSubAccount.displayName);
    commit(SET_ACTIVE_VOLUME_SUBSCRIPTION, activeSubAccount.volumeSubscription);
    commit(SET_ACTIVE_SUB_ACCOUNT_ID, activeSubAccount.id);
  },
  async [FETCH_SUB_ACCOUNT_ARCHIVES]({ commit, dispatch }, activeItem) {
    commit(SET_FETCH_SUB_ACCOUNT_ARCHIVES_STATUS, PENDING_STATUS);
    commit(SET_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID, activeItem.subAccountId);
    await axios.get('/archives', {
      params: {
        subAccountId: activeItem.subAccountId
      }
    }).then(function (response) {
      commit(SET_SUB_ACCOUNT_ARCHIVES, response.data);
    }).finally(function () {
      commit(SET_FETCH_SUB_ACCOUNT_ARCHIVES_STATUS, UNDEFINED_STATUS);
    });
  },
  [UPDATE_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID]({ commit, dispatch }, subAccountId) {
    commit(SET_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID, subAccountId);
  },
  [UPDATE_ACTIVE_NAV_MENU_ITEM_ID]({ commit, dispatch }, activeNavMenuItemId) {
    if (activeNavMenuItemId !== 'resources') {
      window.localStorage.setItem('activeNavMenuItem', activeNavMenuItemId);
    }
    commit(SET_ACTIVE_NAV_MENU_ITEM_ID, activeNavMenuItemId);
    commit(SET_SEARCH_ENABLED_SATE, false);
  },
  async [FETCH_STORAGE_SPACE]({ commit }, activeItem) {
    commit(SET_FETCH_STORAGE_SPACE_STATUS, PENDING_STATUS);
    await axios.get('/space', {
      params: {
        subAccountId: activeItem.subAccountId,
        volumeSubscription: activeItem.volumeSubscription
      }
    }).then(function (response) {
      const usedSpace = debug ? response.data[0] : response.data;
      commit(SET_STORAGE_SPACE, usedSpace);

      if (usedSpace.subscription !== undefined) {
        commit(SET_USER_SUBSCRIPTION, usedSpace.subscription);
      }
    }).finally(function () {
      commit(SET_FETCH_STORAGE_SPACE_STATUS, UNDEFINED_STATUS);
    });
  },
  async [SETUP_ARCHIVE_PASSWORD]({ commit, dispatch }, setupPasswordForm) {
    commit(SET_SETUP_PASSWORD_STATUS, PENDING_STATUS);
    if (debug) {
      setTimeout(function () {
        if (setupPasswordForm.password === '123') {
          commit(SET_SETUP_PASSWORD_STATUS, SUCCESS_STATUS);
        } else {
          commit(SET_SETUP_PASSWORD_STATUS, ERROR_STATUS);
        }
      }, 1200);
    } else {
      await axios.put('/password', setupPasswordForm)
        .then(function () {
          commit(SET_SETUP_PASSWORD_STATUS, SUCCESS_STATUS);
        }).catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              commit(SET_SETUP_PASSWORD_STATUS, ERROR_STATUS);
            } else if (error.response.status !== 200) {
              commit(SET_SETUP_PASSWORD_STATUS, UNDEFINED_STATUS);
            }
          }
        });
    }
  },
  [RESET_ARCHIVE_PASSWORD_STATUS]({ commit }) {
    commit(SET_SETUP_PASSWORD_STATUS, UNDEFINED_STATUS);
  },
  [UPDATE_ACTIVE_VERSION_PATH]({ commit, dispatch }, activeVersionPath) {
    commit(SET_ACTIVE_VERSION_PATH, activeVersionPath);
  },
  [UPDATE_ACTIVE_VOLUME_PATH]({ commit, dispatch }, activeVolumePath) {
    commit(SET_ACTIVE_VOLUME_PATH, activeVolumePath);
  },
  async [FETCH_CONTENT_ITEMS]({ commit, dispatch }, selectedItem) {
    commit(SET_SEARCH_RESULT_RECEIVED, false);
    commit(SET_FETCH_CONTENT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_CONTENT_ITEMS, []);

    if (selectedItem.path === '') {
      commit(SET_ACTIVE_VERSION_PATH, '');
      commit(SET_ACTIVE_VOLUME_PATH, '');
      contentTableSortOptions = defaultSortOptions;
    }

    await axios.get('/content', {
      params: {
        archiveId: selectedItem.archiveId,
        path: selectedItem.path
      }
    }).then(function (response) {
      commit(SET_ACTIVE_FOLDER_ITEM, {
        path: selectedItem.path,
        displayName: selectedItem.path === '' ? '' : selectedItem.displayName,
        isSearchFolder: false
      });

      let content = [];
      if (debug) {
        content = response.data[0] !== undefined ? response.data[0].data : [];
      } else {
        content = response.data.data;
      }

      dispatch(SORT_CONTENT_ITEMS, {
        items: content,
        columnName: contentTableSortOptions.columnName,
        sortOrder: contentTableSortOptions.sortOrder
      });

      const isSearchable = content.length > 0 ?
        (content[0].itemGroup !== 'version' && content[0].itemGroup !== 'volume') : false;

      commit(SET_SEARCH_ENABLED_SATE, isSearchable);
    }).finally(function () {
      commit(SET_FETCH_CONTENT_ITEMS_STATUS, UNDEFINED_STATUS);
    });
  },
  async [SEARCH_CONTENT_ITEMS]({ commit, dispatch }, selectedItem) {
    commit(SET_FETCH_CONTENT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_CONTENT_ITEMS, []);

    // hack to show path column in the content table in correct order
    commit(SET_ACTIVE_CONTENT_TYPE, UNDEFINED_CONTENT_TYPE);
    commit(SET_SEARCH_RESULT_RECEIVED, true);
    await new Promise(resolve => setTimeout(resolve, 200));
    commit(SET_ACTIVE_CONTENT_TYPE, CONTENT_TABLE_TYPE);

    await axios.get('/search', {
      params: {
        archiveId: selectedItem.archiveId,
        volumePath: selectedItem.volumePath,
        path: selectedItem.path,
        searchText: selectedItem.searchText
      }
    }).then(function (response) {
      commit(SET_ACTIVE_FOLDER_ITEM, {
        path: selectedItem.path,
        displayName: selectedItem.searchText,
        isSearchFolder: true
      });

      const content = debug ? response.data : response.data.data;

      dispatch(SORT_CONTENT_ITEMS, {
        items: content,
        columnName: contentTableSortOptions.columnName,
        sortOrder: contentTableSortOptions.sortOrder
      });
    }).finally(function () {
      commit(SET_FETCH_CONTENT_ITEMS_STATUS, UNDEFINED_STATUS);
    });
  },
  [UPDATE_ACTIVE_CONTENT_TYPE]({ commit }, activeContentType) {
    commit(SET_ACTIVE_CONTENT_TYPE, activeContentType);
  },
  async [FETCH_SHARED_CONTENT_ITEMS]({ commit, dispatch }) {
    commit(SET_FETCH_SHARED_CONTENT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_SHARED_CONTENT_ITEMS, []);
    await axios.get('/shared')
      .then(function (response) {
        dispatch(SORT_SHARED_CONTENT_ITEMS, {
          items: response.data,
          columnName: 'displayName',
          sortOrder: 'ascending'
        });
        sendSharedLinksStatistic(response.data);
      }).finally(function () {
        commit(SET_FETCH_SHARED_CONTENT_ITEMS_STATUS, UNDEFINED_STATUS);
      });
  },
  async [FETCH_FILE_VERSIONS]({ commit, dispatch }, selectedItem) {
    commit(SET_FETCH_FILE_VERSIONS_STATUS, PENDING_STATUS);
    commit(SET_FILE_VERSIONS, []);
    await axios.get('/versions', {
      params: {
        archiveId: selectedItem.archiveId,
        path: selectedItem.path
      }
    }).then(function (response) {
      const sortedData = response.data.sort((a, b) => b.id - a.id);
      commit(SET_FILE_VERSIONS, sortedData);
    }).finally(function () {
      commit(SET_FETCH_FILE_VERSIONS_STATUS, UNDEFINED_STATUS);
    });
  },
  async [CREATE_SHARED_LINK]({ commit, dispatch }, selectedItem) {
    commit(SET_CREATE_SHARED_LINK_STATUS, PENDING_STATUS);
    await axios.get('/share', {
      params: {
        archiveId: selectedItem.archiveId,
        path: selectedItem.path,
        ver: selectedItem.fileVersion
      }
    }).then(function (response) {
      commit(SET_SHARED_LINK, response.data);
    }).finally(function () {
      commit(SET_CREATE_SHARED_LINK_STATUS, COMPLETED_STATUS);
    });
  },
  async [DELETE_SHARED_LINK]({ commit, dispatch }, sharedLink) {
    commit(SET_DELETE_SHARED_LINK_STATUS, PENDING_STATUS);
    await axios.delete('/share', {
      params: {
        linkId: sharedLink.linkId
      }
    }).finally(function () {
      commit(SET_DELETE_SHARED_LINK_STATUS, COMPLETED_STATUS);
    });
  },
  async [FETCH_SHARED_LINK_SETTINGS]({ commit, dispatch }, sharedLink) {
    commit(SET_FETCH_SHARED_LINK_SETTINGS_STATUS, PENDING_STATUS);
    await axios.get('/shareSettings', {
      params: {
        linkId: sharedLink.linkId
      }
    }).then(function (response) {
      const content = debug ? response.data[0] : response.data;
      commit(SET_SHARED_LINK_SETTINGS, content);
    }).finally(function () {
      commit(SET_FETCH_SHARED_LINK_SETTINGS_STATUS, COMPLETED_STATUS);
    });
  },
  async [UPDATE_SHARED_LINK_SETTINGS]({ commit, dispatch }, setupSharedLinkSettingsForm) {
    commit(SET_UPDATE_SHARED_LINK_SETTINGS_STATUS, PENDING_STATUS);
    await axios.put('/shareSettings', setupSharedLinkSettingsForm)
      .finally(function () {
        commit(SET_UPDATE_SHARED_LINK_SETTINGS_STATUS, COMPLETED_STATUS);
      });
  },
  [SORT_CONTENT_ITEMS]({ commit, dispatch }, data) {
    contentTableSortOptions = {
      columnName: data.columnName,
      sortOrder: data.sortOrder
    };
    const sortedItems = contentSort(data.items, data.columnName, data.sortOrder);
    commit(SET_CONTENT_ITEMS, sortedItems);
  },
  [SORT_SHARED_CONTENT_ITEMS]({ commit, dispatch }, data) {
    const sortedItems = contentSort(data.items, data.columnName, data.sortOrder);
    commit(SET_SHARED_CONTENT_ITEMS, sortedItems);
  }
};
